import { render, staticRenderFns } from "./CustomerInfoValCellRenderer.vue?vue&type=template&id=540b9be2&"
import script from "./CustomerInfoValCellRenderer.vue?vue&type=script&lang=js&"
export * from "./CustomerInfoValCellRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports